import React, { useState } from "react";

const Accordion = ({ course }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (!course || !course.modules) {
    return <p>No se encontraron módulos.</p>;
  }

  return (
    <div className="accordion-container">
      {course.modules.map((module, index) => (
        <div key={index} className="accordion-item">
          <button
            className={`accordion-header ${activeIndex === index ? "active" : ""}`}
            onClick={() => toggleAccordion(index)}
          >
            {module.title}
            <span className="arrow">{activeIndex === index ? "▲" : "▼"}</span>
          </button>
          <div className={`accordion-content ${activeIndex === index ? "show" : ""}`}>
            {module.content}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Accordion;
